import { produce } from 'immer';
import cloneDeep from 'lodash/cloneDeep';
import ACTION_TYPE from '../../store/ACTION_TYPE';
import createReducerFunction from '../../store/reducerCreator';
import { AppId, Editor } from '../common/interfaces';

export interface State {
    shouldUpdate: boolean;
    editorsApps?: Editor[];
    collaborationAppsHierarchy?: AppId[];
    collaborationAppsPrioritizationEnabled?: boolean;
    isFetching: boolean;
    isFetched: boolean;
    stateUpdate: {
        editorsOrder?: Editor[];
    };
}

export enum CoeditPolicies {
    Ask = 'ask',
    AlwaysCoedit = 'alwaysCoedit',
    NeverCoedit = 'neverCoedit',
}

export interface CoeditPolicy {
    word: CoeditPolicies;
    excel: CoeditPolicies;
    powerpoint: CoeditPolicies;
    userCanOverwrite: boolean;
    arePoliciesEnabled: boolean;
}

export const initialState = {
    shouldUpdate: false,
    editorsApps: [],
    collaborationAppsHierarchy: [],
    collaborationAppsPrioritizationEnabled: false,
    isFetching: false,
    isFetched: false,
    stateUpdate: {
        editorsOrder: [],
    },
};

interface Action {
    type:
        | ACTION_TYPE.REQUEST_EDITORS_FULFILLED
        | ACTION_TYPE.REQUEST_EDITORS_REJECTED
        | ACTION_TYPE.REQUEST_EDITORS
        | ACTION_TYPE.REQUEST_EDITORS_FAKE_PROTECT_SESSION
        | ACTION_TYPE.REQUEST_APPS_FULFILLED
        | ACTION_TYPE.UPDATE_EDITORS_ORDER
        | ACTION_TYPE.SAVE_NEW_COLLABORATION_APPS_HIERARCHY_FULFILLED
        | ACTION_TYPE.SAVE_NEW_COLLABORATION_APPS_HIERARCHY_REJECTED;

    payload?: {
        editorsApps: Editor[];
        collaborationAppsHierarchy: AppId[];
        coeditPolicy?: CoeditPolicy;
        collaborationAppsPrioritizationEnabled: boolean;
        editorsOrder: Editor[];
    };
}

export default createReducerFunction<State, Action>({
    initialState: cloneDeep(initialState),
    reducers: {
        [ACTION_TYPE.REQUEST_EDITORS_FULFILLED]: (state, { payload }) => ({
            ...state,
            isFetched: true,
            isFetching: false,
            shouldUpdate: false,
            coeditPolicy: payload?.coeditPolicy,
            editorsApps: payload?.editorsApps,
            collaborationAppsHierarchy: payload?.collaborationAppsHierarchy,
            collaborationAppsPrioritizationEnabled: payload?.collaborationAppsPrioritizationEnabled,
        }),
        [ACTION_TYPE.REQUEST_EDITORS_REJECTED]: (state) => ({ ...state, isFetching: false, shouldUpdate: false }),
        [ACTION_TYPE.REQUEST_EDITORS]: (state) => ({ ...state, isFetching: true }),
        [ACTION_TYPE.REQUEST_EDITORS_FAKE_PROTECT_SESSION]: (state) => ({
            ...state,
            isFetched: true,
            isFetching: false,
            shouldUpdate: false,
            editorsApps: [],
            collaborationAppsHierarchy: [],
            collaborationAppsPrioritizationEnabled: false,
        }),
        [ACTION_TYPE.REQUEST_APPS_FULFILLED]: (state) =>
            produce(state, (draft) => {
                draft.shouldUpdate = true;
            }),
        [ACTION_TYPE.UPDATE_COEDIT_POLICY_FULFILLED]: (state, { payload }) => ({
            ...state,
            coeditPolicy: payload?.coeditPolicy,
        }),
        [ACTION_TYPE.UPDATE_EDITORS_ORDER]: (state, { payload }) => ({
            ...state,
            stateUpdate: {
                ...state.stateUpdate,
                editorsOrder: payload?.editorsOrder,
            },
        }),
        [ACTION_TYPE.SAVE_NEW_COLLABORATION_APPS_HIERARCHY_FULFILLED]: (state, { payload }) => ({
            ...state,
            collaborationAppsHierarchy: payload?.collaborationAppsHierarchy,
            collaborationAppsPrioritizationEnabled: payload?.collaborationAppsPrioritizationEnabled,
        }),
        [ACTION_TYPE.SAVE_NEW_COLLABORATION_APPS_HIERARCHY_REJECTED]: (state) => ({ ...state }),
    },
});
